import { reduce } from "lodash-es";
import { stringify } from "query-string";

export const formatUrl = (url: string): string => {
  if (!url || url.startsWith("http")) {
    return url;
  }

  if (url.startsWith("://")) {
    return `http${url}`;
  }

  if (url.startsWith("//")) {
    return `http:${url}`;
  }

  return `http://${url}`;
};

export const isValidUrl = (url: string): boolean => {
  if (!url) {
    return false;
  }

  let urlToTest = url;

  // (new URL()) can't handle URLs without protocol
  if (!url.startsWith("http")) {
    urlToTest = `http://${url}`;
  }

  try {
    // create URL
    const testURL = new URL(urlToTest);

    // URL should at least have a top-level-domain (eg. be)
    // and a second-level-domain separated by a period (eg. wieni.be)
    if (!testURL.host.includes(".")) {
      return false;
    }

    const domainLevels = testURL.host.split(".");
    const topLevel = domainLevels[domainLevels.length - 1];

    // top-level-domain should be at least 2 characters
    if (topLevel.length < 2) {
      return false;
    }

    return true;
  } catch {
    // if (new URL()) fails, it's not a valid URL
    return false;
  }
};

/*
  used to add params to a url (from the PATHS constant).
  Provide an object with key, value pairs of the params to replace.
*/
export const buildUrl = (
  path: string,
  params: { [key: string]: string },
  hash?: string,
  queryParams?: { [key: string]: string }
) => {
  return `${reduce(
    params,
    (newPath: string, value, key) => newPath.replace(`:${key}`, value),
    path
  )}${queryParams ? `?${stringify(queryParams)}` : ""}${
    hash ? `#${hash}` : ""
  }`;
};
